import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pie",
  "use": "icon-pie-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pie\"><path d=\"M480 64v416c0 38.4 25.6 64 64 64H960c0 262.4-217.6 480-480 480S0 806.4 0 544 217.6 64 480 64z\" fill=\"\" p-id=\"4793\" /><path d=\"M576 0c249.6 0 448 198.4 448 448H576V0z\" fill=\"\" p-id=\"4794\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol